<template>
  <div class="bg-surface rounded-extra-large relative flex w-full flex-col">
    <div ref="heroEl" class="mx-auto flex w-full max-w-340 flex-row items-center p-5">
      <slot name="hero" />
    </div>
    <div
      v-if="hasHeaderSlot"
      class="bg-surface sticky top-0 z-50 shrink-0"
      :class="showHeader ? '' : 'invisible h-0 overflow-hidden'"
      :inert="!showHeader"
      :aria-hidden="!showHeader"
    >
      <slot name="header" />
    </div>
    <div class="flex flex-row">
      <div class="shrink grow"></div>
      <div class="max-w-5xl grow px-4 pb-8">
        <slot />
      </div>
      <div class="shrink grow"></div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed, onMounted, onUnmounted, ref, useSlots } from 'vue'
  import { useIntersectionObserver } from '@vueuse/core'

  const slots = useSlots()
  const hasHeaderSlot = computed(() => !!slots.header)

  const heroEl = ref<HTMLElement | null>(null)
  const showHeader = ref(false)
  let previousOverflowAnchor = ''

  // The compact header grows into the top of the page. Scroll anchoring would
  // fight that and jump the body scroller.
  onMounted(() => {
    previousOverflowAnchor = document.body.style.overflowAnchor
    document.body.style.overflowAnchor = 'none'
  })

  onUnmounted(() => {
    document.body.style.overflowAnchor = previousOverflowAnchor
  })

  useIntersectionObserver(
    heroEl,
    ([entry]) => {
      if (!entry?.rootBounds || !hasHeaderSlot.value) {
        showHeader.value = false
        return
      }

      // Header takes the top only once the hero has left the viewport.
      showHeader.value = entry.boundingClientRect.bottom <= entry.rootBounds.top + 1
    },
    { threshold: 0 },
  )
</script>
